import { render, staticRenderFns } from "./EmpresaForm.vue?vue&type=template&id=7fdeb665&scoped=true"
import script from "./EmpresaForm.vue?vue&type=script&lang=js"
export * from "./EmpresaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdeb665",
  null
  
)

export default component.exports